@if (isReferralEnabled()) {
  <div class="referral">
    @switch (type()) {
      @case ('banner') {
        @if (shouldShowBanner()) {
          <ng-container *ngTemplateOutlet="referralBannerTpl" />
        }
      }
      @case ('button') {
        <ng-container *ngTemplateOutlet="referralButtonTpl" />
      }
    }
  </div>
}

<!-- Banner -->
<ng-template #referralBannerTpl>
  <div class="referral__banner">
    <div class="flex flex-1 justify-end">
      <div (click)="onCloseBanner()" class="close-button">
        <mat-icon svgIcon="icon_close_16" class="icon-16" />
      </div>
    </div>

    <div class="flex flex-row p-20">
      <div class="info">
        <h2>Know a team that needs Blaze? Send them our way!</h2>
        <p>
          Give another team their breakthrough — introduce them to Blaze. When they come on board,
          you each get $1,000, as a gift card or credit toward your Blaze account.
        </p>

        <p class="font-medium text-accent uppercase">Limited Time</p>
      </div>

      <div class="action">
        <div class="bonus">
          <div class="bonus__item">
            <span>You Get</span>
            <span class="text-accent">$1,000</span>
          </div>
          <div>
            <mat-icon class="icon-16 text-primary-lighter" svgIcon="icon_direction_right_16" />
          </div>
          <div class="bonus__item">
            <span>They Get</span>
            <span class="text-accent">$1,000</span>
          </div>
        </div>

        <button
          (click)="onOpenReferralDialog()"
          blazeButton="primary"
          blazeButtonSize="xxl"
          class="refer-button"
          data-cy="Referral:referButton"
        >
          Refer a company
          <mat-icon class="icon-16" svgIcon="icon_direction_right_16" />
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Button -->
<ng-template #referralButtonTpl>
  <div
    (click)="onOpenReferralDialog()"
    blazeTooltip="Refer a team to Blaze"
    class="referral__button"
  >
    <mat-icon svgIcon="gift_40" class="icon-16" />
  </div>
</ng-template>
